module.exports = __webpack_public_path__ + "img/amapa.9b7fc759.jpg";